import { useMemo } from "react";
import { useEntities } from "./useEntities";

export function useBusinessEntityIds(): number[] {
    const businessEntities = useEntities({ onlyBusiness: true });
    return useMemo(() => businessEntities.map((e) => e.id), [businessEntities]);
}

/**
 * Ids of accessible business (non-mock) entities, in a stable order. Shared so
 * the accounting ledger prefetch (`useWarmLedgerCaches`) and the General Ledger
 * lookup (`useLedgersByEntityIds`) key their queries off the exact same list —
 * otherwise GL could miss the warmed cache entry and refetch.
 */
export function useBusinessNonMockEntityIds(): number[] {
    const entities = useEntities({
        onlyBusiness: true,
        excludeMockEntities: true,
    });
    return useMemo(() => entities.map((entity) => entity.id), [entities]);
}
